const post = function(path, params) {
    const form = document.createElement("form");
    form.method = "post";
    form.action = path;
    form.target = "_blank";

    for (var key in params) {
        if (params.hasOwnProperty(key)) {
            const hiddenField = document.createElement("input");
            hiddenField.type = "hidden";
            hiddenField.name = key;
            hiddenField.value = params[key];

            form.appendChild(hiddenField);
        }
    }

    document.body.appendChild(form);
    form.submit();
};

if (!window.sticker) {
    let id = $("#report-id").val();
    $.ajax({
        method: "POST",
        url: window.windowStickerUrl,
        data: { reportId: id },
        success: function(response) {
            if (!response.html) {
                return;
            }

            $(".hide-sticker-item").removeClass("hide-sticker-item");
            $("#sticker-cont").html(response.html);
        },
        error: function(error) {
            console.log(error);
        }
    });
}


let spec = document.querySelector(".view-all-btn");
if (spec) {
    spec.addEventListener("click", () => {
        const bLazy = new Blazy();
        bLazy.revalidate();
    });
}
let toucheee = document.querySelector(".img-container-slider");
if (toucheee) {
    toucheee.addEventListener("owl-carousel", () => {
    });
}

let repMenu = document.querySelector("#rep-nav");
if (repMenu) {
    repMenu.addEventListener("mouseover", () => {
        const bLazy = new Blazy();
        bLazy.revalidate();
    });
}

let moreImg = document.querySelector(".more-img");
if (moreImg) {
    moreImg.addEventListener("click", () => {
        const bLazy = new Blazy();
        bLazy.revalidate();
    });
}

$(() => {
    $("meta[name=\"viewport\"]").attr("content", "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0");

    let pdfInterval = {};

    $(document).on("click", ".get-pdf", function(e) {

        e.preventDefault();

        const getBtn = $(this);
        const id = getBtn.data("id");

        if (getBtn.hasClass("blinking")) {
            return;
        }

        getBtn.addClass("blinking");

        $.ajax({
            method: "POST",
            headers: { Accept: "application/json" },
            url: getPdfUrl,
            data: { hash: id },
            success: json => {
                console.log(json);
                if (json.success) {
                    pdfInterval[id] = { func: setInterval(checkPdf, 3000, id), cnt: 0 };
                }
            }
        });
    });

    function downloadURI(uri, name) {
        var link = document.createElement("a");
        link.download = name;
        link.href = uri;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const checkPdf = (id) => {
        let getBtn = $(`.get-pdf[data-id='${id}']`);

        if (!pdfInterval.hasOwnProperty(id)) {
            return;
        }

        if (pdfInterval[id]["cnt"] > 9) {
            clearInterval(pdfInterval[id]["func"]);
            delete pdfInterval[id];
            getBtn.removeClass("blinking");
        }

        $.ajax({
            method: "POST",
            headers: { Accept: "application/json" },
            url: checkPdfUrl,
            data: { hash: id },
            success: json => {
                console.log(json);
                if (json.success) {
                    if (pdfInterval.hasOwnProperty(id)) {
                        clearInterval(pdfInterval[id]["func"]);
                    }
                    delete pdfInterval[id];

                    getBtn.removeClass("blinking");
                    getBtn.removeClass("get-pdf");
                    getBtn.attr("href", json.link);
                    getBtn.attr("target", "_blank");
                    downloadURI(json.link, "report.pdf");

                } else {
                    if (pdfInterval.hasOwnProperty(id)) {
                        pdfInterval[id]["cnt"]++;
                    }
                }
            },
            error: response => {
            },
            complete: response => {
            }
        });
    };

    $(document).on("click", ".more-img", function(e) {
        $(this).hide().parents(".sale").addClass("show");
        $(this).hide().parents(".sale").addClass("loader");
        setTimeout(() => {
            window.scroll(0, window.pageYOffset + 1);
            $(".sale.loader").removeClass("loader");
        }, 500);
        const bLazy = new Blazy();
        bLazy.revalidate();
    });

    $(document).on("click", ".view-all-btn", function(e) {
        $(this).hide(100);
        e.preventDefault();
        let fh = $(this).siblings(".show-more");
        fh.removeClass("d-none");
        fh.data("height", fh.height()).css("height", "auto").data("full-height", fh.height()).height(fh.data("height")).animate({ height: fh.data("full-height") }, 300, function() {
            fh.css("height", "auto").parents(".rep-table").addClass("open");
        });
    });

    $("a.js-scroll-trigger[href*=\"#\"]:not([href=\"#\"])").click(function() {
        let target = $(this.hash);
        if (target.length) {
            $("html, body").stop().animate({
                scrollTop: (target.offset().top - 90)
            }, 600);
            return false;
        }
    });


    $("body").scrollspy({ target: "#rep-menu", offset: 200 });

    $(function() {
        $("[data-toggle=\"tooltip\"]").tooltip({
            customClass: "custom-tooltip"
        });

        let isTooltipShown = false;

        $("[data-toggle=\"tooltip\"]").on("touchstart", function() {
            if (!isTooltipShown) {
                $(this).tooltip("show");
                isTooltipShown = true;
            } else {
                $(this).tooltip("hide");
                isTooltipShown = false;
            }
        });

        $(document).on("touchstart", function(e) {
            if (!$(e.target).closest("[data-toggle=\"tooltip\"]").length) {
                $("[data-toggle=\"tooltip\"]").tooltip("hide");
                isTooltipShown = false;
            }
        });
    });


    if (window.blockchain) {
        $(".bc-confirm").addClass("btn-validate");
        $(document).on("click", ".btn-validate", function() {
            post("//validate.vinchain.io", { "check": window.blockchain });
        });
    }

    $(".owl-carousel").width(document.documentElement.clientWidth - 42);

    var owl = $(".owl-carousel").owlCarousel({
        loop: false,
        dots: false,
        items: 1,
        lazyLoad: true,
        stagePadding: 40,
        lazyLoadEager: 1,
        margin: 10
    });

    $(window).resize(function() {
        if (owl.length > 0) {
            $(".owl-carousel").width(document.documentElement.clientWidth - 42);
            owl.data("owl.carousel")._invalidated.width = true;
            owl.trigger("refresh.owl.carousel");
        }
    });

    let rating = 0;
    let textReview = $("#text-review");
    let ratingBlock = $(".rating");

    $(".rating_review > input[type='radio']").click(() => {
        rating = $(".rating_review > input[type='radio']:checked").val();
        $(".number-rating").html("<span class=\"number-rating-click\">" + rating + "</span>/5");
    });

    $(".full").click(() => {
        ratingBlock.removeClass("empty-rating");
    });

    textReview.on("input", () => {
        textReview.removeClass("empty-review");
    });

    $("#send-review").click((e) => {
        e.preventDefault();

        if (!textReview.val()) {
            textReview.addClass("empty-review");
            return;
        }
        if (rating === 0) {
            ratingBlock.addClass("empty-rating");
            return;
        }

        let token = $("#recaptchaResponseReview").val();
        let reportId = $("#report-id").val();
        $.ajax({
            type: "POST",
            url: reportReviewUrl,
            dataType: "json",
            data: { rating, review: textReview.val(), reportId, recaptcha_response: token },
            success: function(json) {
                let classModal = ".high-rating";
                rating < 4 && (classModal = ".low-rating");

                $(classModal).removeClass("d-none");
                $(".rating__stars--before").css("width", (rating * 10) * 2 + "%");
                $("#review-modal").modal("show");
                $(".review-block").addClass("d-none");
                $("#review").css("padding", "0px");
            }
        });

    });
});
